export const ROUTES = {
    auth: 'Auth',
    authLogin: 'AuthLogin',
    authReset: 'AuthReset',
    authSetNewPassword: 'AuthSetNewPassword',
    register: 'Register',
    inviteUser: 'InviteUser',
    inviteOfferUser: 'inviteOfferUser',
    reporting: 'Reporting',
    manageCampaigns: 'ManageCampaigns',
    detailCampaigns: 'DetailCampaigns',
    manageTrafficSources: 'ManageTrafficSources',
    detailTrafficSource: 'DetailTrafficSource',
    manageVendors: 'ManageVendors',
    detailVendor: 'DetailVendor',
    manageBuyers: 'ManageBuyers',
    detailBuyer: 'DetailBuyer',
    manageDestinationGroups: 'ManageDestinationGroups',
    detailDestinationGroup: 'DetailDestinationGroup',
    manageDestinations: 'ManageDestinations',
    detailDestination: 'DetailDestination',
    manageNumbers: 'ManageNumbers',
    manageGlobalOffers: 'ManageGlobalOffers',
    manageOffers: 'ManageOffers',
    detailGlobalOffer: 'DetailGlobalOffer',
    detailOffer: 'DetailOffer',
    manageRequests: 'ManageRequests',
    detailOfferFromRequests: 'DetailOfferFromRequests',
    buyNumbers: 'BuyNumbers',
    detailNumber: 'DetailNumber',
    blockNumber: 'BlockNumber',
    managePools: 'ManagePools',
    detailPool: 'DetailPool',
    manageWorkspace: 'ManageWorkspace',
    detailWorkspaceRole: 'DetailWorkspaceRole',
    gettingStart: 'GettingStart',
    securitySettings: 'SecuritySettings',
    manageBilling: 'ManageBilling',
    rechargeBalance: 'RechargeBalance',
    loginSecurity: 'LoginSecurity',
    paymentHistory: 'PaymentHistory',
    apiAccessTokens: 'ApiAccessTokens',
    manageCards: 'ManageCards',
    workspaceActivity: 'WorkspaceActivity',
    detailWorkspaceActivity: 'DetailWorkspaceActivity',
    notFoundWorkspace: 'NotFoundWorkspace',
    notFound: 'NotFound',
    accountDisabled: 'AccountDisabled',
    verification: 'verification',
    questionnaire: 'questionnaire',
    whiteLabel: 'WhiteLabel',
    manageIntegrations: 'ManageIntegrations',
    googleAdsIntegration: 'GoogleAdsIntegration',
    googleAdsIntegrationTrafficSource: 'GoogleAdsIntegrationTrafficSource',
    facebookAdsIntegration: 'FacebookAdsIntegration',
    facebookAdsIntegrationTrafficSource: 'FacebookAdsIntegrationTrafficSource',
    facebookAdsIntegrationTrafficSourceEventLogs: 'FacebookAdsIntegrationTrafficSourceEventLogs',

    incomingWebhooksIntegration: 'IncomingWebhooksIntegration',
    outgoingWebhooksIntegration: 'OutgoingWebhooksIntegration',
    byocIntegration: 'ByocIntegration',
    byocNumbers: 'ByocNumbers',
    byocCarriers: 'ByocCarriers',
    detailByocIntegrationCarrier: 'DetailByocIntegrationCarrier',

    detailIncomingWebhooksIntegration: 'DetailIncomingWebhooksIntegration',
    detailOutgoingWebhooksIntegration: 'DetailOutgoingWebhooksIntegration',
    detailOutgoingWebhooksLogIntegration: 'DetailOutgoingWebhooksLogIntegration',
    callFlows: 'CallFlows',
    detailCallFlows: 'DetailCallFlows',
    disputes: 'Disputes',
    voipShield: 'VoipShield',
    detailVoipShield: 'detailVoipShield',
    tcpaShield: 'TcpaShield',
    detailTcpaShield: 'detailTcpaShield',
    manageLeads: 'ManageLeads',
    customParameters: 'CustomParameters',
    pingPostLog: 'PingPostLog',
    ratesExpenses: 'RatesExpenses',
    rtbLog: 'RtbLog',
    notificationSettings: 'NotificationSettings',

    offerPreview: 'OfferPreview',

    accountDetails: 'AccountDetails',
}
